import { render, staticRenderFns } from "./PilihKelasXI.vue?vue&type=template&id=49165d02&"
import script from "./PilihKelasXI.vue?vue&type=script&lang=js&"
export * from "./PilihKelasXI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports